import React,{useState, useEffect} from "react";
import { get } from "../../store/config/register";
import { FiEdit2,FiX } from "react-icons/fi";
import { parse,format } from "date-fns";
import Main from "../../components/template/Main";

const headerProps = {
    icon: 'envelope-o',
    title: 'Atividades'
  }

export default function AtividadesResponsavel() {
   const [atividades, setAtividades] =useState ([]);

   async function buscaAtividades() {
    const ativi =  await get('/Atividade/v1/Responsavel/36')
        console.log(ativi)
    if(ativi.length > 0) {
      setAtividades(ativi);
    }
  }
   useEffect(()=>{
    buscaAtividades();
   },[])

    function renderForm() {

        return (
            <div> 
                {renderTable()}
            </div>
        );
    }

   

    function renderTable(){
        return (
        <div className="table">
            <table>
               <thead>
                  <tr>
                    <th scope="col" >Atividade</th>
                    <th scope="col" >Data</th>
                    <th scope="col" ></th>
                  </tr>
               </thead>
                <tbody>
                  {atividades === undefined ? null : atividades.map((atividade,index) => {
                    return (
                        <tr key={index}>
                        <td data-label="Atividade">{atividade.titulo}</td>
                        <td data-label="Data">{format(parse(atividade.data_Prevista,"yyyy-MM-dd'T'HH:mm:ss", new Date()),"dd/MM/yyyy HH:mm") }</td>
                        <td  data-label="">
                        <button className="action" id="btn1" style={{backgroundColor: '#F99E08' ,marginRight: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Editar" onClick={() => true}>
                         <FiEdit2 color="#FFF" size={17} />
                        </button>
                        <button className="action" style={{backgroundColor: '#ff0000',marginRight: "10px" ,marginTop: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Excluir Espaço" onClick={()=> true} >
                         <FiX color="#FFF" size={17} />
                        </button>
                         </td>
                          </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
        )
    }


    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}